import {Directive} from "@angular/core";
import type {AppRoute} from "../app.routes";
import type {OptionalNullable} from "../helpers/TypeHelpers";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[routerLink]:not([rfNoTypedRouterLink])",
  // Inputs defined here to move await from @Input but not use signals since we don't store anything anyway.
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [{name: "routerLink", required: true}],
})
export class RouterLinkAppRoute {
  public set routerLink(_: OptionalNullable<Readonly<AppRoute>>) {
    // We don't store the router link again here. It's just for type validation.
  }
}
